/**
 * Show guide lines on those cases :
 * - help align elements 
 */
fx.ns("shared.stage", class GuideLines extends fx.Component {

    constructor(mouse, model) {
        super();

        this._mouse = mouse;
        this.model = model;

        this._tolerance = fx.get("settings").tolerance || 2;

        this._OFFEST = 0.5;

        // so if current page is deleted, GuideLines is not deleted
        this.autoDelete = false;

        this.listenUpdates(this.model.zoom);
    }

    get creation() {
        return this._creation;
    }

    set creation(val) {
        this._creation = val;
    }

    get currentArea() {
        return this._currentArea;
    }

    set currentArea(val) {
        this._currentArea = val;

        if (this._currentArea)
            this.data = this._currentArea.data;
        else
            this.data = null;

        this._updateMap();
    }


    move(x, y, scale) {
        this.css({
            "transform": "scale(" + scale + ") translate(" + x + "px, " + y + "px)"
        });
    }

    render() {
        let html = '<div class="line guide vertical center"></div>';
        html += '<div class="line guide vertical left"></div>';
        html += '<div class="line guide vertical right"></div>';
        html += '<div class="line guide horizontal center"></div>';
        html += '<div class="line guide horizontal top"></div>';
        html += '<div class="line guide horizontal bottom"></div>';

        html += '<div class="grid ' + (this._moving ? "visible" : "") + '">';

        if (this.currentArea && this.currentArea.data && this.creation) {
            let pageWidth = this.creation.pageWidth;
            let pageHeight = this.creation.pageHeight;
            let precision = fx.get("settings").precision * this.creation.extraScale;

            // For Cover, we don't display grid on slice. Slice will be managed differently
            if (this.currentArea.data.isCover) {
                // it looks like this part is not used
                if (this.currentArea.single && fx.get("app") != "calendar") {
                    let start = ((this.currentArea.pageWidth) / 2) + (this.currentArea.displayedSide == "right" ? this.currentArea.extraWidth : 0);

                    for (let i = 1; i < (pageWidth / precision); i++)
                        html += '<div class="line vertical" style="top:-' + this._OFFEST + 'px;left:' + (start + i * precision - this._OFFEST) + 'px"></div>';

                    // cut in 2 parts
                    for (let i = 1; i < (pageHeight / precision); i++)
                        html += '<div class="line horizontal" style="width:' + (pageWidth) + 'px;left:' + (start) + 'px;top:' + (i * precision - this._OFFEST) + 'px"></div>';
                }
                else {
                    for (let i = 1; i < (pageWidth / precision); i++)
                        html += '<div class="line vertical" style="top:-' + this._OFFEST + 'px;left:' + (i * precision - this._OFFEST) + 'px"></div>';

                    for (let i = (pageWidth + this.creation.sliceWidth) / precision + 1; i < (this.creation.coverWidth / precision); i++)
                        html += '<div class="line vertical" style="top:-' + this._OFFEST + 'px;left:' + (i * precision - this._OFFEST) + 'px"></div>';

                    // cut in 2 parts
                    for (let i = 1; i < (pageHeight / precision); i++) {
                        html += '<div class="line horizontal" style="width:' + (pageWidth) + 'px;left:-' + this._OFFEST + 'px;top:' + (i * precision - this._OFFEST) + 'px"></div>';
                        html += '<div class="line horizontal" style="width:' + (pageWidth) + 'px;left:' + (-this._OFFEST + pageWidth + this.creation.sliceWidth) + 'px;top:' + (i * precision - this._OFFEST) + 'px"></div>';
                    }
                }

            }
            else {
                // for page, we take into account backcover
                let start = 1;
                let finish = (this.currentArea.single || fx.get("app") == "calendar") ? pageWidth : (pageWidth * 2);
                let width = "100%";
                let left = - this._OFFEST;

                if (!this.currentArea.single && this.currentArea.data.hasbackcover) {
                    width = pageWidth + "px";

                    if (this.currentArea.data.isFirstPage) {
                        left = pageWidth - this._OFFEST;
                        start = pageWidth / precision;
                    }
                    else {
                        finish = pageWidth;
                    }

                }

                //if ((this.currentArea.data.hasbackcover && this.currentArea.data.isLastPage) || !this.currentArea.data.hasbackcover)
                //    html += '<div class="line vertical lostborder" style="top:0px;left:0px;width:' + this.currentArea.data.lostBorder + 'px"></div>';

                for (let i = start; i < (finish / precision); i++)
                    html += '<div class="line vertical" style="top:-' + this._OFFEST + 'px;left:' + (i * precision - this._OFFEST) + 'px"></div>';

                //if ((this.currentArea.data.hasbackcover && this.currentArea.data.isFirstPage) || !this.currentArea.data.hasbackcover)
                //    html += '<div class="line vertical lostborder" style="top:0px;left:' + (pageWidth* (this.currentArea.single ? 1 : 2) - precision) + 'px;width:' + this.currentArea.data.lostBorder + 'px"></div>';

                //html += '<div class="line horizontal lostborder" style="width:' + ((this.currentArea.data.hasbackcover || this.currentArea.single ? 1 : 2)*pageWidth) + 'px;height:' + this.currentArea.data.lostBorder + 'px;left:' + (this.currentArea.data.hasbackcover ? (this.currentArea.data.isLastPage ? 0 : pageWidth) : 0) + 'px;top:0px"></div>';

                for (let i = 1; i < (pageHeight / precision); i++)
                    html += '<div class="line horizontal" style="width:' + width + ';left:' + left + 'px;top:' + (i * precision - this._OFFEST) + 'px"></div>';

                //html += '<div class="line horizontal lostborder" style="width:' + ((this.currentArea.data.hasbackcover || this.currentArea.single ? 1 : 2)*pageWidth) + 'px;height:' + this.currentArea.data.lostBorder + 'px;left:' + (this.currentArea.data.hasbackcover ? (this.currentArea.data.isLastPage ? 0 : pageWidth) : 0) + 'px;top:' + (pageHeight - this.currentArea.data.lostBorder) + 'px"></div>';

            }


        }
        html += "</div>";

        return html;
    }

    _refreshHandlers() {
        this.lineCenterVertical = this.find(".line.vertical.center");
        this.lineLeft = this.find(".line.vertical.left");
        this.lineRight = this.find(".line.vertical.right");

        this.lineCenterHorizontal = this.find(".line.horizontal.center");
        this.lineTop = this.find(".line.horizontal.top");
        this.lineBottom = this.find(".line.horizontal.bottom");

        this.grid = this.find(".grid");
    }

    onReady() {
        this.on("resize", this._windowResized, window);
    }

    _windowResized() {
        this.update();
    }

    _position() {
        if (this.currentArea) {

            this.css({
                transform: this.currentArea.css("transform"),
                zoom: this.currentArea.css("zoom"),
                top: (this.currentArea instanceof shared.stage.CalendarCover) ? this.currentArea.realHeight * this.currentArea.scale : 0,
                left: 0,
                width: this.currentArea.realWidth,
                height: this.currentArea.realHeight,
            });
        }
    }


    start(element, area) {
        if (element && element instanceof shared.stage.components.Background)
            return;

        if (!area)
            return;

        this.currentArea = area;

        this.currentElement = element;

        this._moving = true;

        this._position();

        if (!fx.get("settings").gridmode)
            return;

        if (!fx.browser.isMobile && !fx.browser.isTablet)
            this.addClass(this.grid, "visible");
    }

    stop() {
        this._moving = false;

        this.currentElement = null;

        this.css(this.lineCenterVertical, { display: "none" });
        this.css(this.lineLeft, { display: "none" });
        this.css(this.lineRight, { display: "none" });

        this.css(this.lineCenterHorizontal, { display: "none" });
        this.css(this.lineTop, { display: "none" });
        this.css(this.lineBottom, { display: "none" });

        if (!fx.get("settings").gridmode)
            return;

        this.removeClass(this.grid, "visible");
        this.removeClass(this.lineCenterVertical, "pageCenter");
        this.removeClass(this.lineCenterHorizontal, "pageCenter");

    }

    // TODO : udpdate elementWidth, elementHeight when glue is detected
    check(x, y, elementWidth, elementHeight, angle, element) {
        if (fx.browser.isMobile)
            return;

        if (!this.currentElement || !this._map)
            return;

        let bounding = fx.graphics.getBoundingRect({ x: x, y: y, width: elementWidth, height: elementHeight }, angle);

        let lines = {};
        this._OFFESTH = 0.5;
        this._OFFESTV = 1;

        for (let i = 0; i < this._map.length; i++) {
            let map = this._map[i];

            if (element.id == map.id)
                continue;

            // Left
            if (!lines.left) {
                if (Math.abs(bounding.x - map.x) < this._tolerance)
                    lines.left = { value: map.x };
                else
                    if (Math.abs(bounding.x + bounding.width - map.x) < this._tolerance)
                        lines.left = { value: map.x };
            }


            // right
            if (!lines.right) {
                if (Math.abs(bounding.x + bounding.width - map.x - map.width) < this._tolerance)
                    lines.right = { value: map.x + map.width - this._OFFESTH };
                else
                    if (Math.abs(bounding.x - map.x - map.width) < this._tolerance)
                        lines.right = { value: map.x + map.width - this._OFFESTH };
            }

            // top
            if (!lines.top) {
                if (Math.abs(bounding.y - map.y) < this._tolerance)
                    lines.top = { value: map.y - this._OFFESTV };
                else
                    if (Math.abs(bounding.y + bounding.height - map.y) < this._tolerance)
                        lines.top = { value: map.y - this._OFFESTV };
            }

            // bottom
            if (!lines.bottom) {
                if (Math.abs(bounding.y + bounding.height - map.y - map.height) < this._tolerance)
                    lines.bottom = { value: map.y + map.height - this._OFFESTV };
                else
                    if (Math.abs(bounding.y - map.y - map.height) < this._tolerance)
                        lines.bottom = { value: map.y + map.height - this._OFFESTV };
            }


            // horizontal center element
            if (!lines.centerVertical) {
                if (Math.abs(bounding.x + (bounding.width / 2) - map.x - (map.width) / 2) < this._tolerance * 1.5)
                    lines.centerVertical = { value: map.x + (map.width / 2) };
            }
            // vertical center element
            if (!lines.centerHorizontal) {
                if (Math.abs((bounding.y + (bounding.height / 2)) - (map.y + (map.height / 2))) < this._tolerance * 1.5)
                    lines.centerHorizontal = { value: map.y + (map.height / 2) };
            }

            // vertical cover/page center
            if (lines.centerVertical) {
                if (Math.abs((bounding.x + (bounding.width / 2) - this.creation.pageWidth / 2)) < this._tolerance * 1.5)
                    this.addClass(this.lineCenterVertical, "pageCenter");
                else
                    if (this.currentArea instanceof shared.stage.Cover && Math.abs((bounding.x + (bounding.width / 2) - this.creation.pageWidth / 2 - this.creation.pageWidth - this.creation.sliceWidth)) < this._tolerance * 1.5)
                        this.addClass(this.lineCenterVertical, "pageCenter");
                    else
                        if (this.currentArea instanceof shared.stage.Page && Math.abs((bounding.x + (bounding.width / 2) - this.creation.pageWidth / 2 - this.creation.pageWidth)) < this._tolerance * 1.5)
                            this.addClass(this.lineCenterVertical, "pageCenter");
                        else
                            this.removeClass(this.lineCenterVertical, "pageCenter");
            }

            // horizontal book center
            if (lines.centerHorizontal) {
                if (Math.abs((bounding.y + (bounding.height / 2)) - this.creation.pageHeight / 2) < this._tolerance * 1.5)
                    this.addClass(this.lineCenterHorizontal, "pageCenter");
                else
                    this.removeClass(this.lineCenterHorizontal, "pageCenter");
            }

            // check if on lostBorder
            this.checkElement(element, bounding);

            let offset = 0;
            if (this.currentArea.single) {
                if (this.currentArea.displayedSide == "right")
                    offset = ((this.currentArea.pageWidth) / 2);
                else
                    if (this.currentArea.displayedSide == "left")
                        offset = 0;
            }

            // pages with backcover
            if (this.currentArea.data && this.currentArea.data.hasbackcover) {
                // left backcover
                if (this.currentArea.data.isFirstPage && bounding.x > this.creation.pageWidth) {
                    this.css(this.lineLeft, { display: (lines.left ? "block" : "none"), top: 0, left: (lines.left ? lines.left.value : 0) - offset });

                    this.css(this.lineRight, { display: (lines.right ? "block" : "none"), top: 0, left: (lines.right ? lines.right.value : 0) - offset });

                    this.css(this.lineTop, { display: (lines.top ? "block" : "none"), top: lines.top ? lines.top.value : 0, left: -offset + this.creation.pageWidth, width: this.creation.pageWidth });

                    this.css(this.lineBottom, { display: (lines.bottom ? "block" : "none"), top: lines.bottom ? lines.bottom.value : 0, left: -offset + this.creation.pageWidth, width: this.creation.pageWidth });

                    this.css(this.lineCenterVertical, { display: (lines.centerVertical ? "block" : "none"), top: 0, left: (lines.centerVertical ? lines.centerVertical.value : 0) - offset });

                    this.css(this.lineCenterHorizontal, { display: (lines.centerHorizontal ? "block" : "none"), top: lines.centerHorizontal ? lines.centerHorizontal.value : 0, left: -offset + this.creation.pageWidth, width: this.creation.pageWidth });

                }
                else
                    // right backcover
                    if (this.currentArea.data.isLastPage && bounding.x <= this.creation.pageWidth) {
                        this.css(this.lineLeft, { display: (lines.left ? "block" : "none"), top: 0, left: (lines.left ? lines.left.value : 0) - offset });

                        this.css(this.lineRight, { display: (lines.right ? "block" : "none"), top: 0, left: (lines.right ? lines.right.value : 0) - offset });

                        this.css(this.lineTop, { display: (lines.top ? "block" : "none"), top: lines.top ? lines.top.value : 0, left: -offset, width: this.creation.pageWidth });

                        this.css(this.lineBottom, { display: (lines.bottom ? "block" : "none"), top: lines.bottom ? lines.bottom.value : 0, left: -offset, width: this.creation.pageWidth });

                        this.css(this.lineCenterVertical, { display: (lines.centerVertical ? "block" : "none"), top: 0, left: (lines.centerVertical ? lines.centerVertical.value : 0) - offset });

                        this.css(this.lineCenterHorizontal, { display: (lines.centerHorizontal ? "block" : "none"), top: lines.centerHorizontal ? lines.centerHorizontal.value : 0, left: -offset, width: this.creation.pageWidth });

                    }
            }
            else
            // other pages
            {
                if (!(this.currentArea instanceof shared.stage.CalendarCover)) // TODO : fix lines with Calendar Cover single
                {
                    this.css(this.lineLeft, { display: (lines.left ? "block" : "none"), top: 0, left: (lines.left ? lines.left.value : 0) - offset });

                    this.css(this.lineRight, { display: (lines.right ? "block" : "none"), top: 0, left: (lines.right ? lines.right.value : 0) - offset });

                    this.css(this.lineTop, { display: (lines.top ? "block" : "none"), top: lines.top ? lines.top.value : 0, left: -offset });

                    this.css(this.lineBottom, { display: (lines.bottom ? "block" : "none"), top: lines.bottom ? lines.bottom.value : 0, left: -offset });

                    this.css(this.lineCenterVertical, { display: (lines.centerVertical ? "block" : "none"), top: 0, left: (lines.centerVertical ? lines.centerVertical.value : 0) - offset });

                    this.css(this.lineCenterHorizontal, { display: (lines.centerHorizontal ? "block" : "none"), top: lines.centerHorizontal ? lines.centerHorizontal.value : 0, left: -offset });
                }

            }

            if (lines.left && lines.right && lines.top && lines.bottom && lines.centerHorizontal && lines.centerVertical)
                break;

        }


        //        return position;
    }

    checkElement(element, bounding) {
        if (!this.currentArea || !this.currentArea.data)
            return;

        bounding = bounding || fx.graphics.getBoundingRect({ x: element.x, y: element.y, width: element.width, height: element.height }, element.rotation);

        let warning;

        // case when text is too close from lost border
        if (element.data.isText) {
            warning = (bounding.x < this.currentArea.data.lostBorder) ||
                (bounding.y <= 0) ||
                (bounding.x < this.currentArea.data.lostBorder) ||
                (bounding.x + bounding.width > (2 * this.creation.pageWidth) + ((this.currentArea instanceof shared.stage.Cover) ? this.creation.sliceWidth : 0) - this.currentArea.data.lostBorder) ||
                (bounding.y + bounding.height >= this.creation.pageHeight);
        }
        else
            // case when image is on middle of book (faces might be broken)
            if (element.data.isPhoto && this.creation.cover_option != models.ProductBook.LAYFLAT) {
                warning = this.currentArea instanceof shared.stage.Page && !this.currentArea.data.hasbackcover &&
                    bounding.x < this.creation.pageWidth &&
                    bounding.x + bounding.width > this.creation.pageWidth;
            }

        if (!this.creation.isCalendar)
            element.addPositionWarning(warning);

    }

    _dataUpdated(e) {
        super._dataUpdated(e);

        if (e.action.type == "update" &&
            e.action.model instanceof models.CreationElementContent &&
            e.action.model != this.currentElement &&
            e.action.impacts("x", "y", "width", "height", "rotation"))
            this._updateMap();
    }

    // let's add borders
    _updateMap() {
        this._map = [];

        if (!this.currentArea || !this.currentArea.stage)
            return;

        let childs = this.currentArea.stage.getChilds();
        for (let i = 0; i < childs.length; i++) {
            let child = childs[i];

            if (child instanceof shared.stage.components.Background)
                continue;

            this._map.push({
                x: child.x,
                y: child.y,
                width: child.width,
                height: child.height,
                id: child.id
            });

        }

        // let's add area, so borders are also managed
        // depending on cover, page (backcover)
        this._map.push({
            x: 0,
            y: 0,
            width: this.creation.pageWidth,
            height: this.creation.pageHeight,
            id: this.currentArea.id
        });

        this._map.push({
            x: this.creation.pageWidth + ((this.currentArea instanceof shared.stage.Cover) ? this.creation.sliceWidth : 0),
            y: 0,
            width: this.creation.pageWidth,
            height: this.creation.pageHeight,
            id: this.currentArea.id
        });

    }

});